import { render, staticRenderFns } from "./HighestBids.vue?vue&type=template&id=07270786&"
import script from "./HighestBids.vue?vue&type=script&lang=js&"
export * from "./HighestBids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports